import React, { Children } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import { MODAL_STYLES } from 'styleguide';

import { Scrollbars } from 'react-custom-scrollbars';

import IconClose from 'icons/Close';

import Wrapper from './Wrapper';
import Close from './Close';
import TransparentBottom from './TransparentBottom';

class ConfirmModal extends React.PureComponent {
  render() {
    return (
      <ReactModal
        isOpen={this.props.isOpen}
        contentLabel={this.props.contentLabel}
        onRequestClose={this.props.onClose}
        ariaHideApp={false}
        style={{
          overlay: { ...MODAL_STYLES.overlay },
          content: { ...MODAL_STYLES.content, ...this.props.styles },
        }}
      >
        <Wrapper>
          <Close onClick={this.props.onClose}>
            <IconClose />
          </Close>
          {this.props.height
            ? (
              <React.Fragment>
                <Scrollbars style={{ height: `${this.props.height}px` }} autoHide>
                  {Children.toArray(this.props.children)}
                </Scrollbars>
                <TransparentBottom />
              </React.Fragment>
            )
            : Children.toArray(this.props.children)
          }
        </Wrapper>
      </ReactModal>
    );
  }
}

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool,
  contentLabel: PropTypes.string,
  onClose: PropTypes.func,
  height: PropTypes.string,
  children: PropTypes.node,
  styles: PropTypes.shape({}),
};

ConfirmModal.defaultProps = {
  isOpen: false,
  contentLabel: '',
  onClose: () => {},
  height: '',
  children: null,
  styles: {},
};

export default ConfirmModal;
